import { Link } from 'react-router-dom';
import {
  Content,
  ListCountSelect,
  ListFooter,
  Page,
  Pagination,
  Avatar,
  List,
  LoadingPage,
} from '@trufla-technology/trumarket-react-design-system';
import { useListClients } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { ListClientsBody } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';

import { nameInitials } from '../../utils';
import './style.scss';
import { ClientsListFilter } from '../../widgets/ClientsListFilter';

type ClientStatus = Extract<ListClientsBody['filter'], object>;

export const ClientList = () => {
  const clients = useListClients({
    paginate: { limit: 5, offset: 0 },

    select: [
      'key',
      'name',
      'type',
      'email',
      'status',
      'phoneNumber',
      'managerName',
      'company',
    ],
    sort: [{ sortBy: 'name', sortOrder: 'asc' }],
  });

  if (clients.loading) return <LoadingPage />;

  return (
    <div className="clients-list-page">
      <Content>
        <Page>
          <h1>Clients ({clients.paging?.count})</h1>

          <List
            loading={clients.loading}
            data={clients.data || []}
            columns={[
              {
                field: 'name',
                label: 'Client Name',
                sortOrder: clients.sortIndex.name,
                onSort: () => clients.handleSort('name'),

                render: ({ key, name }) => (
                  <Link to={`/clients/${key}`}>
                    <div className="client-list-avatar">
                      <Avatar>{nameInitials(name)}</Avatar>
                    </div>
                    <span>{name}</span>
                  </Link>
                ),
              },
              {
                field: 'status',
                label: 'Client Status',
                header: () => (
                  <ClientsListFilter
                    selected={clients.query.filter?.status}
                    onChange={(status) =>
                      clients.handleFilter({
                        status: status as ClientStatus['status'],
                      })
                    }
                  />
                ),
                sortOrder: clients.sortIndex.status,
                onSort: () => clients.handleSort('status'),
              },
              {
                field: 'email',
                label: 'Email',
                sortOrder: clients.sortIndex.email,
                onSort: () => clients.handleSort('email'),
              },
              {
                field: 'phoneNumber',
                label: 'Phone Number',
                sortOrder: clients.sortIndex.phoneNumber,
                onSort: () => clients.handleSort('phoneNumber'),
              },
              {
                field: 'managerName',
                label: 'Owner',
                sortOrder: clients.sortIndex.managerName,
                onSort: () => clients.handleSort('managerName'),
              },
              {
                field: 'company',
                label: 'Company',
                sortOrder: clients.sortIndex.company,
                onSort: () => clients.handleSort('company'),
              },
            ]}
            footer={
              <ListFooter>
                <ListCountSelect
                  value={clients.query.paginate?.limit}
                  options={[5, 10, 15, 20]}
                  onChange={clients.handleLimit}
                />
                <Pagination
                  total={clients.paging?.count!}
                  perPage={clients.query.paginate?.limit!}
                  index={
                    clients.query.paginate?.offset! /
                    clients.query.paginate?.limit!
                  }
                  onChange={(index) =>
                    clients.handleOffset(clients.query.paginate?.limit! * index)
                  }
                />
              </ListFooter>
            }
          />
        </Page>
      </Content>
    </div>
  );
};
